import React, { useState, useEffect } from 'react';
import './App.css';
import imagen1 from './img1.png';
import imagen2 from './img2.png';
import imagen3 from './img3.png';
import imagen4 from './img4.png';
import imagen5 from './img5.png';
import imagen6 from './img6.png';
import imagen7 from './img7.png';
import imagen8 from './img8.png';

export default function MemoryGame() {
  const [gameState, setGameState] = useState('menu');
  const [flipped, setFlipped] = useState(new Set());
  const [matched, setMatched] = useState(new Set());
  const [moves, setMoves] = useState(0);
  const [time, setTime] = useState(0);
  const [ranking, setRanking] = useState([]);
  const [playerName, setPlayerName] = useState('');
  const [soundEnabled, setSoundEnabled] = useState(true);
  const [customImages, setCustomImages] = useState([]);
  const [useCustom, setUseCustom] = useState(false);

  // Emojis por defecto
  /*const defaultPairs = [
    { id: 1, emoji: '🚀', label: 'Cohete' },
    { id: 2, emoji: '🎮', label: 'Videojuego' },
    { id: 3, emoji: '🌟', label: 'Estrella' },
    { id: 4, emoji: '🎨', label: 'Paleta' },
    { id: 5, emoji: '⚡', label: 'Rayo' },
    { id: 6, emoji: '🎯', label: 'Objetivo' },
    { id: 7, emoji: '🏆', label: 'Trofeo' },
    { id: 8, emoji: '💎', label: 'Diamante' },
  ];*/


const defaultPairs = [
  { id: 1, image: imagen1, label: 'Imagen 1' },
  { id: 2, image: imagen2, label: 'Imagen 2' },
  { id: 3, image: imagen3, label: 'Imagen 3' },
  { id: 4, image: imagen4, label: 'Imagen 4' },
  { id: 5, image: imagen5, label: 'Imagen 5' },
  { id: 6, image: imagen6, label: 'Imagen 6' },
  { id: 7, image: imagen7, label: 'Imagen 7' },
  { id: 8, image: imagen8, label: 'Imagen 8' },
];

  const cards = useCustom && customImages.length === 8 
    ? customImages.map((img, i) => ({ id: i, image: img }))
    : defaultPairs;

  // Crear las tarjetas mezcladas solo una vez al inicio del juego
  const [gameCards, setGameCards] = useState([]);

  useEffect(() => {
    const shuffled = [...cards, ...cards].sort(() => Math.random() - 0.5);
    setGameCards(shuffled);
  }, [gameState]);

  // Timer
  useEffect(() => {
    if (gameState === 'playing') {
      const timer = setInterval(() => setTime(t => t + 1), 1000);
      return () => clearInterval(timer);
    }
  }, [gameState]);

  // Verificar parejas
  useEffect(() => {
    if (flipped.size === 2) {
      const [first, second] = Array.from(flipped);
      const firstId = gameCards[first].id;
      const secondId = gameCards[second].id;

      if (firstId === secondId) {
        playSound('match');
        setMatched(prev => new Set([...prev, firstId]));
        setFlipped(new Set());
      } else {
        playSound('fail');
        setTimeout(() => setFlipped(new Set()), 800);
      }
      setMoves(m => m + 1);
    }
  }, [flipped, gameCards]);

  // Verificar victoria
  useEffect(() => {
    if (gameState === 'playing' && matched.size === cards.length && matched.size > 0) {
      playSound('win');
      saveScore();
      setGameState('victory');
    }
  }, [matched, gameState, cards.length]);

  const playSound = (type) => {
    if (!soundEnabled) return;
    try {
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();
      
      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);
      
      if (type === 'match') {
        oscillator.frequency.value = 800;
        gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
        gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.2);
        oscillator.start(audioContext.currentTime);
        oscillator.stop(audioContext.currentTime + 0.2);
      } else if (type === 'fail') {
        oscillator.frequency.value = 300;
        gainNode.gain.setValueAtTime(0.2, audioContext.currentTime);
        gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.15);
        oscillator.start(audioContext.currentTime);
        oscillator.stop(audioContext.currentTime + 0.15);
      } else if (type === 'win') {
        oscillator.frequency.value = 1000;
        gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
        gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5);
        oscillator.start(audioContext.currentTime);
        oscillator.stop(audioContext.currentTime + 0.5);
      }
    } catch (e) {
      console.log('Audio no disponible');
    }
  };

  const saveScore = () => {
    const newScore = {
      name: playerName || 'Anónimo',
      moves,
      time,
      score: Math.max(1000 - (moves * 10) - time, 0)
    };
    const updated = [...ranking, newScore].sort((a, b) => b.score - a.score).slice(0, 10);
    setRanking(updated);
  };

  const startGame = () => {
    setGameState('playing');
    setFlipped(new Set());
    setMatched(new Set());
    setMoves(0);
    setTime(0);
  };

  const handleCardClick = (index) => {
    if (flipped.size >= 2 || flipped.has(index) || matched.has(gameCards[index].id)) return;
    setFlipped(prev => new Set([...prev, index]));
    playSound('flip');
  };

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    if (files.length !== 8) {
      alert('Por favor sube exactamente 8 imágenes');
      return;
    }
    const readers = files.map(file => {
      return new Promise(resolve => {
        const reader = new FileReader();
        reader.onload = (event) => resolve(event.target.result);
        reader.readAsDataURL(file);
      });
    });
    Promise.all(readers).then(images => {
      setCustomImages(images);
      setUseCustom(true);
    });
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  // Menú principal
  if (gameState === 'menu') {
    return (
      <div className="menu-container">
        <div className="menu-card">
          <h1 className="menu-title">Memory Game</h1>
          <p className="menu-subtitle">Encuentra todas las parejas y compite en el ranking</p>
          
          <div className="menu-form">
            <div className="form-group">
              <label>Tu nombre:</label>
              <input
                type="text"
                value={playerName}
                onChange={(e) => setPlayerName(e.target.value)}
                placeholder="Ingresa tu nombre"
                className="input-text"
              />
            </div>
          </div>

          <button onClick={startGame} className="btn-play">
            Jugar
          </button>

          {ranking.length > 0 && (
            <div className="ranking-section">
              <h2 className="ranking-title">🏆 Top 10 Ranking</h2>
              <div className="ranking-list">
                {ranking.map((score, idx) => (
                  <div key={idx} className="ranking-item">
                    <div className="ranking-left">
                      <span className="ranking-position">#{idx + 1}</span>
                      <span className="ranking-name">{score.name}</span>
                    </div>
                    <div className="ranking-right">
                      <span className="ranking-moves">{score.moves} mvs</span>
                      <span className="ranking-time">{formatTime(score.time)}</span>
                      <span className="ranking-score">{score.score} pts</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  // Pantalla de juego
  if (gameState === 'playing') {
    return (
      <div className="game-container">
        <div className="game-wrapper">
          {/* Header */}
          <div className="game-header">
            <h1 className="game-title">Memory Game</h1>
            <div className="game-stats">
              <div className="stat-box">
                <span className="stat-label">⏱️</span>
                <span className="stat-value">{formatTime(time)}</span>
              </div>
              <div className="stat-box">
                <span className="stat-label">🎯</span>
                <span className="stat-value">{moves}</span>
              </div>
              <button 
                onClick={() => setSoundEnabled(!soundEnabled)}
                className="btn-sound"
              >
                {soundEnabled ? '🔊' : '🔇'}
              </button>
            </div>
          </div>

          {/* Grid de tarjetas */}
          <div className="cards-grid">
            {gameCards.map((card, index) => (
              <button
                key={index}
                onClick={() => handleCardClick(index)}
                disabled={flipped.has(index) || matched.has(card.id)}
                className={`card ${flipped.has(index) || matched.has(card.id) ? 'card-flipped' : 'card-back'}`}
              >
                {flipped.has(index) || matched.has(card.id) ? (
                  <div className="card-content">
                    {card.emoji ? card.emoji : <img src={card.image} alt="card" className="card-image" />}
                  </div>
                ) : (
                  <div className="card-back-content">?</div>
                )}
              </button>
            ))}
          </div>

          {/* Barra de progreso */}
          <div className="progress-section">
            <div className="progress-info">
              <span>Progreso</span>
              <span>{matched.size} / {cards.length} parejas</span>
            </div>
            <div className="progress-bar">
              <div 
                className="progress-fill"
                style={{ width: `${(matched.size / cards.length) * 100}%` }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Pantalla de victoria
  if (gameState === 'victory') {
    const finalScore = Math.max(1000 - (moves * 10) - time, 0);
    return (
      <div className="victory-container">
        <div className="victory-card">
          <div className="victory-emoji">🎉</div>
          <h1 className="victory-title">¡Lo hiciste!</h1>
          <p className="victory-subtitle">Completaste el juego exitosamente</p>

          <div className="victory-stats">
            <div className="stat-row">
              <span className="stat-label">Movimientos:</span>
              <span className="stat-value-large">{moves}</span>
            </div>
            <div className="stat-row">
              <span className="stat-label">Tiempo:</span>
              <span className="stat-value-large">{formatTime(time)}</span>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-row">
              <span className="stat-label">Puntuación:</span>
              <span className="stat-value-score">{finalScore} pts</span>
            </div>
          </div>

          <div className="victory-buttons">
            <button
              onClick={() => setGameState('menu')}
              className="btn-menu"
            >
              Volver al menú
            </button>
            <button
              onClick={startGame}
              className="btn-again"
            >
              🔄 Jugar de nuevo
            </button>
          </div>
        </div>
      </div>
    );
  }
}